import axios from 'axios'
import { getEnvVars } from '../Utils/env-utils';
var theEnv = getEnvVars(window.location.hostname);
//const apiUrl = 'https://dev-api.ascension.org/rxonboardingapi';
const { apiUrl } = getEnvVars(window.location.hostname);
export const registerCard = ({
    sessionToken,
    ccToken,
    ccDetailsDTO: {
        cardHolderInfoDTO,
        cardInfoDTO,
        billingAddressDTO
    }
}, onSuccess, onError) => {
    axios.post(`${apiUrl}/card/registercard`,
        {
            sessionToken,
            ccToken,
            ccDetailsDTO: {
                cardHolderInfoDTO,
                cardInfoDTO,
                billingAddressDTO
            }
        }
        , {
            headers: {
                apikey: theEnv.REACT_APP_API_KEY_URI,
            }
        })
        .then(res => {
            console.log(res)
            onSuccess(res);
        })
        .catch(e => onError(e));
};
//https://dev-api.ascension.org/rxonboardingapi/card/verifoneConfig
export const verifoneConfig = (sessionToken, onSuccess, onError) => { //TODO
    axios.post(`${apiUrl}/card/verifoneConfig`,
        {
            sessionToken: sessionToken
        }, {
        headers: {
            apikey: theEnv.REACT_APP_API_KEY_URI,
        }
    })
        .then(res => {
            console.log(res)
            onSuccess(res); // onSuccess will build the iframe
        })
        .catch(e => onError(e));
}